















































































































































































































































































import VueOptions from '@utils/VueOptions'
import Modal from '@components/Modal'
import dma from '@assets/dma.json'
import states from '@assets/states.json'
import event_types from '@assets/event_types.json'
import UiList from '@superUI/List/List'
import RequestButton from '@/components/RequestButton'
import ResourceList from '@modules/ui/List/ResourceList'
import LoadingIndicator from '@/components/LoadingIndicator'
import DropdownFilter from '@ui/Filters/DropdownFilter'

settings =
  name: 'EventResourceList'

  vue:
    props: ['events', 'bulkActionResultItems', 'actions', 'listItemActions', 'filtersOverriden', 'infiniteWrapper', 'options']
    components: {
      UiList,
      Modal,
      RequestButton,
      ResourceList,
      LoadingIndicator,
      DropdownFilter
    }

    data: ->
      activeFilter: false
      pageNumber: 1
      clearAllFiltersEnabled: false

      defaultSpaceType: 'product_sampling'
      inventorySelector: []
      # combo_filters:
      #   no_contact_sampling: false

      filters:
        q: ''
        scopes:
          # live_stream: false,
          # physical_event: false,
          we_want_to_distribute_food: null
          we_want_to_distribute_drinks: null
          we_want_to_collect_student_data: null

        filters:
          space_type: ''
          location_setting: '' # Indoors/Outdoors
          min_reach: ''
          max_reach: ''
          starts_after: ''
          starts_before: ''

        bi_filters:
          min_price_for_space_type: ['', '']
          max_price_for_space_type: ['', '']

        multi_filters:
          event_type: []
          public_tags: []
          private_tags: []

        geo_filters:
          location_dma: []
          location_state: []

        sort: [{ field: 'starts_at', order: 'asc' }]

      primeFilters: []

      selectedFilters: []

      rowSize: 3

      spaceTypes: ['booth_10x10', 'booth_10x20', 'booth_20x40', 'booth_40x60', 'product_sampling', 'trailer', 'food_truck', 'social_media_post', 'title_sponsor', 'video_wall']
      spaceTypesBooths: ['booth_10x10', 'booth_10x20', 'booth_20x40', 'booth_40x60']
      spaceTypesOthers: ['product_sampling', 'trailer', 'food_truck']
      spaceTypesMedia: ['social_media_post', 'title_sponsor', 'video_wall']

      all_state_options: states
      event_type_options: event_types

      virtualRealityInfoModal:
        show: false

    beforeMount: ->
      @getAppSession('selectedSpaceType', @defaultSpaceType)
      @inventorySelector = [@defaultSpaceType]
      @filters.filters.space_type = @defaultSpaceType
      @filters.bi_filters.min_price_for_space_type = [@defaultSpaceType, '']
      @filters.bi_filters.max_price_for_space_type = [@defaultSpaceType, '']

    mounted: ->
      @filters = @filtersOverriden if @filtersOverriden?
      @loadFiltersFromURL()
      @resetGeo() if @scanner
      # @renderComboButtons()

    computed:
      components: ->
        {
          'event-feed-card': () => import('./EventFeedCard')
        }

      optionsForSpaceType: ->
        optionsForProductSampling =
          value: 'product_sampling'
          label: 'Recess Sampling'
        optionsForBooth =
          value: 'booth'
          label: 'Onsite Space'
          children: @spaceTypesBooths.map((s) => value: s, label: @$options.filters.formatBoothSize(s))
        optionsForSocialMediaPost =
          value: 'social_media_post'
          label: 'Social Media Post'
        optionsForVideoWall =
          value: 'video_wall'
          label: 'Video Wall'
        # optionsForFoodTruck =
        #   value: 'food_truck'
        #   label: 'Food Truck'
        # optionsForFoodTrailer =
        #   value: 'trailer'
        #   label: 'Mobile Trailer'

        return [optionsForBooth, optionsForProductSampling, optionsForVideoWall,optionsForSocialMediaPost]

      selectedSpaceType: -> @inventorySelector[@inventorySelector.length - 1]
      selectedSpaceTypeIsProductSampling: -> @selectedSpaceType is 'product_sampling'
      dma_options: ->
        # return @scanner.options_for_dma if @scanner.options_for_dma?.length
        Object.keys(dma)
      state_options: ->
        # return @scanner.options_for_state if @scanner.options_for_state?.length
        Object.keys(states)

      title: ->
        @options?.title || 'Events'

      resourceKey: ->
        @options?.resourceKey || 'events'

      scanner: -> @options?.scanner || {}

      selectedEvents: ->
        events = []
        for lineItem in @options.lineItems
          type = @spaceFor(lineItem)?.type
          events.push @eventFor(lineItem) if type is @selectedSpaceType
        events

      selectedFilterLocations: ->
        all_state_options = @all_state_options
        values = [...@filters.geo_filters.location_dma]
        @filters.geo_filters.location_state.forEach((state) -> values.push all_state_options[state])
        values.push @filters.filters.location_setting if @filters?.filters?.location_setting?.length
        values
      selectedFilterDates: ->
        values = []
        startsAfter = dayjs(@filters.filters.starts_after.toString()).format('YYYY-MM-DD') if @filters?.filters?.starts_after?
        startsBefore = dayjs(@filters.filters.starts_before.toString()).format('YYYY-MM-DD') if @filters?.filters?.starts_before?
        values.push startsAfter if startsAfter?.length && startsAfter isnt 'Invalid Date'
        values.push startsBefore if startsBefore?.length && startsBefore isnt 'Invalid Date'
        values
      selectedFilterReach: ->
        values = []
        values.push @filters.filters.min_reach if @filters.filters.min_reach?.trim().length
        values.push @filters.filters.max_reach if @filters.filters.max_reach?.trim().length
        values
      selectedFilterVirtualReach: ->
        values = []
        values.push @filters.filters.min_virtual_reach if @filters.filters.min_virtual_reach?.trim().length
        values.push @filters.filters.max_virtual_reach if @filters.filters.max_virtual_reach?.trim().length
        values
      selectedFilterPrice: ->
        values = []
        values.push @filters.bi_filters.min_price_for_space_type[1] if @filters.bi_filters.min_price_for_space_type?[1]?.length
        values.push @filters.bi_filters.max_price_for_space_type[1] if @filters.bi_filters.max_price_for_space_type?[1]?.length
        values
      selectedFilterEventType: ->
        values = []
        @filters.multi_filters.event_type.forEach((type) =>
          values.push @eventTypeNameForType(type) if type?.length
        )
        values

      selectedFilterPermissions: ->
        values = []
        values.push 'Food Allowed' if @filters.scopes?.we_want_to_distribute_food
        values.push 'Beverages Allowed' if @filters.scopes?.we_want_to_distribute_drinks
        values.push 'Data Collection Allowed' if @filters.scopes?.we_want_to_collect_student_data
        values
      selectedFilterBooths: ->
        value = @$options.filters.formatSpaceType(@selectedSpaceType)
        values = []
        values.push value if value.length and value.includes('Booth')
        values
      selectedFilterLiveStream: ->
        value = @$options.filters.formatSpaceType(@selectedSpaceType)
        values = []
        values.push value if value.length and @spaceTypesMedia.includes(@selectedSpaceType)
        values

      hasStaffPick: -> @filters.multi_filters.private_tags.includes 'staff_pick'


    methods:
      eventFor: (lineItem)-> @ctxEvent lineItem
      spaceFor: (lineItem) -> @eventFor(lineItem)?.spaces?[lineItem.space_name]
      hiInfiniteScroll: (state) ->
        @actions.fetchResource(state, @resourceKey, @formatFiltersPayload(), { page: @pageNumber })
        @pageNumber += 1

      # resetCombos: ->
      #   @combo_filters.no_contact_sampling = false

      # hiActivateVirtual: ->
      #   @resetCombos()
      #   @inventorySelector = ['native_integration']
      #   @filters.multi_filters.event_type = []
      #   @filters.scopes =
      #       live_stream: true
      #       physical_event: false
      #   @filters.multi_filters.virtual_reality = ['live_stream']
      #   @filters.geo_filters =
      #       location_dma: []
      #       location_state: []
      #   @hiApplyFilters()

      # hiActivateDriveInSampling: ->
      #   @combo_filters.virtual = false
      #   @combo_filters.social_distance_sampling = false
      #   @combo_filters.drive_in_sampling = true
      #   @inventorySelector = ['product_sampling']
      #   @filters.multi_filters.event_type = ['movie_show']
      #   @filters.scopes =
      #       live_stream: false
      #       physical_event: true
      #   @filters.multi_filters.virtual_reality = ['physical_event']
      #   @filters.geo_filters =
      #       location_dma: []
      #       location_state: []
      #   @hiApplyFilters()

      hiToggleStaffPick: () ->
        private_tags = @filters.multi_filters.private_tags

        if not @hasStaffPick
          private_tags.push 'staff_pick'
        else
          private_tags =  private_tags.filter (tag) -> tag isnt "staff_pick"

        @filters.multi_filters.private_tags = private_tags
        @hiApplyFilters()

      hiFilterChanged: ->
        # @renderComboButtons()
        @clearAllFiltersEnabled = true

      hiApplyFilters: (selectedFilters) ->
        @$refs.infiniteLoading.stateChanger.reset()
        @selectedFilters = selectedFilters if selectedFilters
        @updateFiltersOnURL()
        @pageNumber = 1
        filtersPayload = @formatFiltersPayload()
        @actions.fetchResource(null, @resourceKey, filtersPayload, { page: @pageNumber })
        @pageNumber += 1

      hiInventoryTypeSelected: () ->
        @filters.filters.space_type = @selectedSpaceType
        @filters.multi_filters.public_tags = @filters.multi_filters.public_tags.filter (tag) -> tag isnt "no_contact_sampling"
        @setAppSession('selectedSpaceType', @selectedSpaceType)
        @hiApplyFilters(@filters)

      formatFiltersPayload: ->
        payload =
          scopes: {},
          filters: {},
          bi_filters: {}
          multi_filters: {}
          geo_filters: {}
          sort: []
        for field, value of @filters.scopes
          payload.scopes[field] = field if value

        for field, value of @filters.filters
          payload.filters[field] = value if value

        for field, value of @filters.bi_filters
          payload.bi_filters[field] = value if value?.length is 2 and (value || [])?.join('').trim().length

        for field, value of @filters.multi_filters
          payload.multi_filters[field] = value if value?.length

        for field, value of @filters.geo_filters
          payload.geo_filters[field] = value if value?.length

        payload.sort = @filters.sort if @filters.sort.length

        payload = @adaptFilterPayload(payload) if @adaptFilterPayload?
        payload

      adaptFilterPayload: (payload) ->
        for field, value of payload.bi_filters
          price_in_cents = parseInt(value[1]) * 100

          if value?.length is 2 and value[1].trim().length
            payload.bi_filters[field] = [@selectedSpaceType, price_in_cents]
          else
            delete payload.bi_filters[field]

        payload.filters.space_type = @inventorySelector[@inventorySelector.length - 1]
        payload

      hiSearchChange: (q = '') ->
        @filters.q = q
        @hiApplyFilters(@filters)

      hiClearFilter: ->
        cleared_filter_scope = @filters.scopes
        Object.keys(cleared_filter_scope).forEach((key) -> cleared_filter_scope[key] = null)
        @selectedFilters = []
        @hiApplyFilters(@filters)

      spaceTypeIsSelected: (type) -> type is @selectedSpaceType

      updateFiltersOnURL: ->
        query =
          inventory: JSON.stringify(@inventorySelector)
        @$router.push({ query })

      loadFiltersFromURL: ->
        @inventorySelector = JSON.parse(@$route.query.inventory) if @$route.query?.inventory?

      hiClearAllFilters: ->
        @hiClearLocationFilter()
        @hiClearDatesFilter()
        @hiClearReachFilter()
        @hiClearVirtualReachFilter()
        @hiClearPriceFilter()
        @hiClearEventTypeFilter()
        @hiClearPermissionsFilter()
        @clearAllFiltersEnabled = false
        @hiApplyFilters()

      hiClearSpecificFilter: (type = null, category = null) ->
        return false if not type
        if category
          @filters[type][category] = if Array.isArray(@filters[type][category]) then [] else ''
        else
          Object.keys(@filters[type]).forEach((item) ->
            @filters[type][item] = if Array.isArray(@filters[type][item]) then [] else ''
          )

      hiClearLocationFilter: ->
        @filters.geo_filters.location_dma = []
        @filters.geo_filters.location_state = []
        @filters.filters.location_setting = ''
        @hiApplyFilters()

      hiClearDatesFilter: ->
        @filters.filters.starts_after = ''
        @filters.filters.starts_before = ''
        @hiApplyFilters()

      hiClearReachFilter: ->
        @filters.filters.min_reach = ''
        @filters.filters.max_reach = ''
        @hiApplyFilters()

      hiClearVirtualReachFilter: ->
        @filters.filters.min_virtual_reach = ''
        @filters.filters.max_virtual_reach = ''
        @hiApplyFilters()

      hiClearPriceFilter: ->
        @filters.bi_filters.min_price_for_space_type = [@selectedSpaceType, '']
        @filters.bi_filters.max_price_for_space_type = [@selectedSpaceType, '']
        @hiApplyFilters()

      hiClearEventTypeFilter: ->
        @filters.multi_filters.event_type = []
        @hiApplyFilters()

      hiClearPermissionsFilter: ->
        @filters.scopes.we_want_to_distribute_food = false
        @filters.scopes.we_want_to_distribute_drinks = false
        @filters.scopes.we_want_to_collect_student_data = false
        @hiApplyFilters()

      eventTypeNameForType: (type) ->
        eventType = @event_type_options.find((item) -> item.id is type)
        eventType.name

      resetGeo: -> # auto select all of the options for dma and state
        @filters.geo_filters.location_dma = @scanner?.options_for_dma
        @filters.geo_filters.location_state = @scanner?.options_for_state
        @filters.filters.location_setting = ''

      # renderComboButtons: ->
      #   @resetCombos()
      #   if @filters.multi_filters.virtual_reality.includes('live_stream') and @inventorySelector.includes('native_integration')
      #     @combo_filters.virtual = true
      #   if @ixnventorySelector.includes('product_sampling') and @filters.multi_filters.virtual_reality.includes('physical_event') and not @filters.multi_filters.event_type.includes('movie_show')
      #     @combo_filters.no_contact_sampling = true
      #   if @inventorySelector.includes('product_sampling') and @filters.multi_filters.virtual_reality.includes('physical_event') and @filters.multi_filters.event_type.includes('movie_show')
      #     @combo_filters.drive_in_sampling = true

      hiToggleVirtualRealityInfoModal: ->
        @virtualRealityInfoModal.show = !@virtualRealityInfoModal.show

export default VueOptions.vue settings
